module.exports = __webpack_public_path__ + "static/img/noProduct698a429.png";